import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(16),
    alignItems: 'center',
});
